import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import RatingIndicator from '../ratingIndicator';
import { getDifferenceBetweenDateRange, updateStringNPPA } from '../../../utility';

const OncologyBox = (props) => {
    const {
        boxData, 
        oncologyId='', 
        selectedOncologyId=-1, 
        handleClick, 
        isRating = false, 
        current, 
        previous, 
        change,
        type='',
        extraFields = false,
        a = [], // remove
        b = [], // remove
        customClass=''
    } = props;

    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const hasExtraFields = ['Completed', 'Dismissed'];
    return (
        <Box
            className={`box-sizing-border-box ${(oncologyId === selectedOncologyId && change>0) ? 'active-oncology-box' : (oncologyId === selectedOncologyId && change<0) ?'decrease-oncology-box': (oncologyId === selectedOncologyId &&(current === previous || change == 0)) ? 'noChange-oncology-box' :'oncology-box'}`}
            onClick={handleClick}
        >
            <Box className="flex-row-space-between-center">
                <Box>
                    <Typography className="text-md-semi-bold gray-900 break-word">
                        {updateStringNPPA(boxData.name)}
                    </Typography>
                </Box>
            </Box>
            <Box className={customClass.title}>
                <Box>
                    <Typography className="display-xs-semi-bold gray-900">
                        {boxData?.volume}
                    </Typography>
                </Box>
                {isRating && <Box>
                    <RatingIndicator current={type!==''?boxData?.current :boxData?.volume} previous={boxData?.previousVolume}/>
                    <Typography className="text-xs-regular gray-500">
                        vs {!isNaN(boxData.previousVolume) && boxData.previousVolume} 
                        (Last {getDifferenceBetweenDateRange(startDateRange, endDateRange)}) 
                    </Typography>
                </Box>}
                <Box />
            </Box>
            <Box>
                { (extraFields && hasExtraFields.includes(boxData.name)) &&
                   (boxData.name === 'Dismissed' ? a : b).map(data=>(
                       <Box className='flex-row-space-between' key={data.name}>
                           <Box>
                               <Typography className='text-sm-semi-bold' key={data.name}>
                                   {data.name + ` [${data.count}]`} 
                               </Typography>
                           </Box>
                           <Box>
                               <Typography className='text-sm-semi-bold' key={data.name}>
                                   {data.percent} %
                               </Typography>
                           </Box>

                       </Box>
                   )
                        
                        
                   )
                }
            </Box>
        </Box>
    );
};

export default OncologyBox;
